module.exports = ".STPStart {\r\n    background-color: lightgoldenrodyellow !important;\r\n    font-weight: bold;\r\n}\r\n\r\n::ng-deep .mat-tooltip {\r\n    white-space: pre-line;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/page-layouts/product-list-tab-child-list/product-release-tab-list.component.css
// module id = 1006
// module chunks = 1